export const rulesConstants = {
  GET_RULES_REQUEST: "GET_RULES_REQUEST",
  GET_RULES_SUCCESS: "GET_RULES_SUCCESS",
  GET_RULES_FAILURE: "GET_RULES_FAILURE",

  GET_LESSON_RULES_REQUEST: "GET_LESSON_RULES_REQUEST",
  GET_LESSON_RULES_SUCCESS: "GET_LESSON_RULES_SUCCESS",
  GET_LESSON_RULES_FAILURE: "GET_LESSON_RULES_FAILURE",

  ADD_LESSON_RULES_REQUEST: "ADD_LESSON_RULES_REQUEST",
  ADD_LESSON_RULES_SUCCESS: "ADD_LESSON_RULES_SUCCESS",
  ADD_LESSON_RULES_FAILURE: "ADD_LESSON_RULES_FAILURE",

  UPDATE_LESSON_RULES_REQUEST: "UPDATE_LESSON_RULES_REQUEST",
  UPDATE_LESSON_RULES_SUCCESS: "UPDATE_LESSON_RULES_SUCCESS",
  UPDATE_LESSON_RULES_FAILURE: "UPDATE_LESSON_RULES_FAILURE",

  UPDATE_LESSON_RULE_REQUEST: "UPDATE_LESSON_RULE_REQUEST",
  UPDATE_LESSON_RULE_SUCCESS: "UPDATE_LESSON_RULE_SUCCESS",
  UPDATE_LESSON_RULE_FAILURE: "UPDATE_LESSON_RULE_FAILURE",

  DELETE_LESSON_RULE_REQUEST: "DELETE_LESSON_RULE_REQUEST",
  DELETE_LESSON_RULE_SUCCESS: "DELETE_LESSON_RULE_SUCCESS",
  DELETE_LESSON_RULE_FAILURE: "DELETE_LESSON_RULE_FAILURE"
}
